<template>
    <v-container fluid>
      <v-row dense>
        <v-col cols="12">
          <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
        </v-col>
        <v-col cols="12">
          <ViewDetails :object="object" type="EjercicioDetail" :itemsAction="tableAction"/>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import ViewDetails from '@/components/ViewDetails'
export default {
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'Fecha Inicio', value: 'fecha_inicio', class: 'black--text' },
          { text: 'Fecha Cierre', value: 'fecha_cierre', class: 'black--text' },
          { text: 'Año', value: 'anio', class: 'black--text' },
          { text: 'Descripcion', value: 'descripcion', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'ActionsLocal', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    user: {},
    form: [],
    objectMain: {},
    url: {},
    message: ''
  }),
  components: {
    DataTableMain,
    ViewDetails
  },
  mounted () {
    this.getUrl('POST/nomina/config/ejercicio/show')
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('POST/nomina/config/ejercicio/show')
    },
    newData (item) {
      this.form = this.get_usersForm
      this.objectMain = {}
      this.url = this.get_urls['POST/nomina/config/ejercicio/store']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 500, title: 'Nuevo Usuario' })
    },
    /* ========== ========== ========== ========== ========== */
    tableAction (item) {
      this[item.action](item)
    },
    toAssignRole (item) {
      this.form = this.get_assignRoles
      this.objectMain = {
        id: item.item.id,
        usuario: item.item.usuario,
        NombreCompleto: item.item.empleado.NombreCompleto,
        roles: item.item.roles
      }
      this.url = this.get_urls['POST/config/auth/usuarios/assign-rol']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 550, title: 'Asignar Rol - Usuario' })
    },
    toEditData (item) {
      this.user = item.item
      this.SHOW_DIALOG_MAIN({ type: 'update', with: 500, title: 'Editar Usuario' })
    },
    /*
    toUpdatePassword (item) {
      this.user = item.item
      this.SHOW_DIALOG_SECOUND_MAIN({ type: 'create', showtype: 'password' })
    },
    toMunicipiosAssign (item) {
      this.SET_DATA_SECOUND_MAIN(item.item)
      router.push({ name: 'ViewMunicipiosRoleAssign', params: { id: item.item.id } })
    },
    */
    ...mapActions(['getUrlServices', 'postServiceListAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: {} })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SHOW_DIALOG_SECOUND_MAIN', 'CLEAR_DATA_LIST', 'SET_DATA_SECOUND_MAIN'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objects', 'get_dialogMain', 'get_usersForm', 'get_assignRoles']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls () {
      this.getUrl('POST/nomina/config/ejercicio/show')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.modelMain = []
        if (vals.length > 0) {
          this.table.modelMain.push(vals[0])
        }
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }

}
</script>

<style>

</style>
crear curd de roles
